/**
 * Add 'ariaToggle', 'ariaShow' and 'ariaHide' plugins.
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  const DATA_KEY = 'save-form-storage-id';
  const DATA_KEY_VALUE_PREFIX = '__form-storage-';

  /**
   * Whether or not a object has the specified property as its own property.
   * 
   * @param {Object} obj
   * @param {String} prop
   * @return {Boolean}
   */
  const objectHasOwnProperty = (obj, prop) => {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };

  let guid = 1;
  let dataStorage = {};

  function saveForm(form) {
    let data = [];
    let storageId = $(form).data(DATA_KEY);

    if (!storageId) {
      storageId = DATA_KEY_VALUE_PREFIX + guid++;
      $(form).data(DATA_KEY, storageId);
    }

    data = $(':input', form).map((idx, elem) => {
      if (elem.nodeName === 'SELECT') {
        if (elem.multiple) {
          return {
            elem: elem,
            checkedOptions: $('option:checked', elem).get()
          };
        }
        else {
          return {
            elem: elem,
            selectedIndex: elem.selectedIndex
          };
        }
      }
      // do not save password && file input
      else if (elem.nodeName === 'INPUT' && elem.type === 'password') {
        return {
          elem: elem,
          value: ''
        };
      }
      else if (elem.nodeName === 'INPUT' && elem.type === 'file') {
        return { };
      }
      else if (elem.nodeName === 'INPUT' && (elem.type === 'checkbox' || elem.type === 'radio')) {
        return {
          elem: elem,
          checked: elem.checked
        };
      }
      else {
        return {
          elem: elem,
          value: elem.value
        };
      }
    }).get();

    dataStorage[storageId] = data;
    
    return data;
  }

  function restoreForm(form) {
    let data;
    let storageId = $(form).data(DATA_KEY);

    if (!storageId) {
      return;
    }

    data = dataStorage[storageId];

    if (!data || !Array.isArray(data)) {
      return;
    }

    const inputs = $(':input', form).get();

    data.forEach(entry => {
      const elem = entry.elem;
      if (elem) {
        const idx = inputs.indexOf(elem);

        if (idx >= 0) {
          inputs.splice(idx, 1);

          if (objectHasOwnProperty(entry, 'checked')) {
            elem.checked = entry.checked;
          }
          else if (objectHasOwnProperty(entry, 'checkedOptions')) {
            const checkeds = entry.checkedOptions;

            $('option', elem).each(function() {
              this.selected = checkeds.includes(this);
            });
          }
          else if (objectHasOwnProperty(entry, 'selectedIndex')) {
            elem.selectedIndex = entry.selectedIndex;
          }
          else if (objectHasOwnProperty(entry, 'value')) {
            elem.value = entry.value;
          }
        }
      }
    });
  }

  
  $.fn['saveForm'] = function() {
    return this.each(function() {
      saveForm(this);
    });
  };

  $.fn['restoreForm'] = function() {
    return this.each(function() {
      restoreForm(this);
    });
  };
})(jQuery, window);